/** Character packs under /avatars — KayKit Adventurers + Skeletons */

export const HUMAN_CHARACTERS = [
  'Casual_Male',
  'Casual_Female',
  'Casual2_Male',
  'Casual2_Female',
  'Casual3_Male',
  'Casual3_Female',
  'Casual_Bald',
  'Suit_Male',
  'Suit_Female',
  'Worker_Male',
  'Worker_Female',
  'Chef_Male',
  'Chef_Female',
  'Doctor_Male_Young',
  'Doctor_Female_Young',
  'Doctor_Male_Old',
  'Doctor_Female_Old',
  'OldClassy_Male',
  'OldClassy_Female',
  'Cowboy_Male',
  'Cowboy_Female',
  'Pirate_Male',
  'Pirate_Female',
  'Soldier_Male',
  'Soldier_Female',
  'BlueSoldier_Male',
  'BlueSoldier_Female',
  'Knight_Male',
  'Knight_Golden_Male',
  'Knight_Golden_Female',
  'Ninja_Male',
  'Ninja_Female',
  'Ninja_Sand',
  'Ninja_Sand_Female',
  'Viking_Male',
  'Viking_Female',
  'Kimono_Male',
  'Kimono_Female',
  'Wizard',
  'Witch',
  'Elf',
  'Goblin_Male',
  'Goblin_Female',
  'Zombie_Male',
  'Zombie_Female',
  'Cow',
  'Pug',
] as const

/** KayKit Adventurers 2.0 (CC0) — GLB + shared Rig_Medium animations */
export const KAYKIT_CHARACTERS = [
  'Kay_Barbarian',
  'Kay_Knight',
  'Kay_Mage',
  'Kay_Ranger',
  'Kay_Rogue',
  'Kay_Rogue_Hooded',
  'Kay_Skeleton_Mage',
  'Kay_Skeleton_Minion',
  'Kay_Skeleton_Rogue',
  'Kay_Skeleton_Warrior',
] as const

export const AVATAR_CHARACTERS = [...HUMAN_CHARACTERS, ...KAYKIT_CHARACTERS] as const

export type AvatarCharacterId = (typeof AVATAR_CHARACTERS)[number]
export type KayKitCharacterId = (typeof KAYKIT_CHARACTERS)[number]

export function isKayKitCharacterId(id: string): boolean {
  return id.startsWith('Kay_')
}

export function resolveCharacterId(raw: string | undefined): AvatarCharacterId {
  if (raw && (AVATAR_CHARACTERS as readonly string[]).includes(raw)) {
    return raw as AvatarCharacterId
  }
  return 'Kay_Knight'
}

export function characterModelUrl(id: AvatarCharacterId): string {
  if (isKayKitCharacterId(id)) {
    const file = id.replace(/^Kay_/, '')
    return `/avatars/kaykit/${file}.glb`
  }
  // Quaternius pack removed from shipping assets — legacy ids use Knight
  return '/avatars/kaykit/Knight.glb'
}

export const KAYKIT_ANIM_MOVEMENT_URL = '/avatars/kaykit/anims/MovementBasic.glb'
export const KAYKIT_ANIM_GENERAL_URL = '/avatars/kaykit/anims/General.glb'

export const QUATERNIUS_MODEL_SCALE = 0.2
export const KAYKIT_MODEL_SCALE = 0.22
